import type { ContestState as PillState } from '@cou/admin-ui';

/** The backend's ContestState enum (packages/contracts). */
export type ContestState = 'Scheduled' | 'Open' | 'Closed' | 'Settled' | 'Canceled';

/**
 * Maps the backend's ContestState + finalisedAt onto the admin-ui StatusPill's lowercase
 * state set. Scheduled splits into draft/scheduled by whether the contest has been finalised
 * (admin-ui.md: "Scheduled — with a draft/finalised distinction").
 */
export function contestPillState(state: ContestState, finalisedAt: string | null): PillState {
  if (state === 'Scheduled') {
    return finalisedAt === null ? 'draft' : 'scheduled';
  }
  return state.toLowerCase() as PillState;
}
